import { getCurrentSession } from "@/utils/localStorage";

export function maxSessionTokenTime() {
  return 480; // 8 horas
}

export function formattedDateTime() {
  const dateNow = new Date();
  const year = dateNow.getFullYear();
  const month = String(dateNow.getMonth() + 1).padStart(2, "0");
  const day = String(dateNow.getDate()).padStart(2, "0");
  const hour = String(dateNow.getHours()).padStart(2, "0");
  const minutes = String(dateNow.getMinutes()).padStart(2, "0");
  const seconds = String(dateNow.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hour}:${minutes}:${seconds}`;
}

export function tokenSessionTime() {
  const currentDateTime = formattedDateTime();
  const sessionTime = getCurrentSession();

  const differenceInMilliseconds =
    new Date(currentDateTime) - new Date(sessionTime);

  return Math.floor(differenceInMilliseconds / 60000);
}

export function checkSessionTokenRemainingTime() {
  const currentSessionTime = tokenSessionTime();
  const maxSessionTime = maxSessionTokenTime();

  return currentSessionTime < maxSessionTime;
}
